import { PopUp } from 'interfaces';
import { get } from 'scripts';
import { API } from 'data/30pay.api';

export const getActivePopUps = async (): Promise<PopUp[]> => {
    const res = await get<PopUp[]>(API.popUp.getActivePopUps);
    return res.value.value ?? [];
};
